// Static decorative mock of the organizer dashboard. Bars are fixed-height divs,
// no chart library. Not interactive.
const STATS = [
  { label: 'Tickets sold', value: '328' },
  { label: 'Raised', value: '$184k' },
  { label: 'RSVPs', value: '402' },
]

// Heights as Tailwind classes so the bar chart renders without inline styles.
const BARS = ['h-10', 'h-16', 'h-12', 'h-20', 'h-14', 'h-24', 'h-28']

export default function DashboardPreview() {
  return (
    <div className="overflow-hidden rounded-2xl border border-black/10 bg-card shadow-xs">
      <div className="border-b border-black/5 px-5 py-3">
        <p className="text-sm font-semibold">Renaissance Ball 2026</p>
        <p className="text-xs text-muted-foreground">Live dashboard</p>
      </div>
      <div className="p-5">
        <div className="grid grid-cols-3 gap-3">
          {STATS.map((s) => (
            <div key={s.label} className="rounded-xl bg-muted/40 px-3 py-3">
              <p className="text-lg font-semibold tabular-nums">{s.value}</p>
              <p className="text-xs text-muted-foreground">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="mt-5">
          <div className="flex items-center justify-between">
            <p className="text-sm font-medium">Sales this week</p>
            <span className="text-xs font-medium text-primary">+18%</span>
          </div>
          <div className="mt-3 flex h-32 items-end justify-between gap-2">
            {BARS.map((h, i) => (
              <div
                key={i}
                className={`${h} w-full rounded-t-md bg-linear-to-t from-primary/40 to-primary`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
